<template>
  <a-card :bordered="false">
    <a-modal v-model="transferible" @ok="addtransfer()" title="转派" :width="600">
      <a-form :form="transferform">
        <a-row>
          <a-col>
            <a-form-item style="display: none">
              <a-input v-decorator="['feedbackHeaderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="转派角色">
              <a-select
                showSearch
                optionFilterProp="children"
                @change="onChangecomplaint"
                :filterOption="filterOption"
                style="width: 300px"
                :allowClear="true"
                v-decorator="['roleCode', { rules: [{ required: true, message: '请选择转派角色!' }] }]"
              >
                <a-select-option v-for="type in pendingMattersRoleList" :key="type.code"
                  >{{ type.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal v-model="dealingible" title="处理" :width="600" footer="">
      <a-form :form="dealingform" v-if="this.feedbackInfo">
        <a-row>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题类型">
              {{ this.feedbackInfo.matterName }}
            </a-form-item>
            <div v-for="(tab, index) in feedbackInfo.itemInfos">
              <div v-if="tab.type == 1">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题内容">
                  {{ tab.contents }}
                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                  <a-upload
                    :action="uploadUrlb"
                    listType="picture-card"
                    :fileList="tab.arrList"
                    :headers="headers"
                    @preview="handlePreview"
                  >
                  </a-upload>
                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="视频">
                  <div style="display: flex; flex-direction: row; width: 100%; flex-wrap: wrap">
                    <div v-for="(item, i) in tab.videos">
                      <video
                        class="video"
                        :key="index"
                        :src="'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + item"
                        controls
                      ></video>
                    </div>
                  </div>
                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申诉人">
                  <span> {{ tab.createName }}</span>
                  <span style="margin-left: 25px">申请时间: {{ tab.createTime }}</span>
                </a-form-item>
              </div>
              <div v-if="tab.type == 1" style="border: 1px solid #ccc"></div>
              <div v-if="tab.type == 2">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理回复">
                  {{ tab.contents }}
                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                  <a-upload
                    :action="uploadUrlb"
                    listType="picture-card"
                    :fileList="tab.arrList"
                    :headers="headers"
                    @preview="handlePreview"
                  >
                  </a-upload>
                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理人">
                  <span> {{ tab.createName }}</span>
                  <span style="margin-left: 25px">申请时间: {{ tab.createTime }}</span>
                </a-form-item>
                <div v-if="tab.type == 2" style="border: 1px solid #ccc"></div>
              </div>
              <div></div>
            </div>
            <a-form :form="replyproblemsform">
              <div v-if="startProcessingible" style="margin: 20px">
                <a-form-item style="display: none">
                  <a-input v-decorator="['feedbackHeaderId']" />
                </a-form-item>
                <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  :label="appealProcessingible ? '申诉内容' : '处理回复'"
                >
                  <a-input
                    v-decorator="['contents', { rules: [{ required: true, message: '请填写内容!' }] }]"
                    type="textarea"
                  />
                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上传文件">
                  <a-upload
                    name="file"
                    :multiple="true"
                    :action="currencyuploadUrl"
                    list-type="picture-card"
                    class="avatar-uploader"
                    :file-list="dealinglist"
                    :headers="headers"
                    @change="dealingChange"
                    @preview="handlePreview"
                  >
                    <a-icon type="upload" />
                    <div class="ant-upload-text">图片</div>
                  </a-upload>
                </a-form-item>
              </div>
            </a-form>
            <div style="text-align: center">
              <a-button
                type="primary"
                style="margin: 20px"
                @click="updateFeedback"
                v-if="!feedbackInfo.handleStartTime && !detailsViewible"
                >修改</a-button
              >
              <!-- <a-button
                type="primary"
                style="margin: 20px"
                @click="revoke"
                v-if="!feedbackInfo.handleStartTime && !detailsViewible"
                >撤回
              </a-button> -->
              <a-button
                type="primary"
                style="margin: 20px"
                @click="startProcessing"
                v-if="!startProcessingible && !processingCompletedible && !appealProcessingible && !detailsViewible"
                >处理</a-button
              >
            </div>
            <div style="text-align: center" v-if="startProcessingible && !appealProcessingible">
              <a-button type="primary" style="margin: 20px" @click="problemsTransfer(feedbackInfo)">转派 </a-button>
              <a-button type="primary" style="margin: 20px" @click="replyproblems">回复</a-button>
              <a-button type="primary" style="margin: 20px" @click="processingCompleted">处理完成 </a-button>
            </div>
            <div style="text-align: center" v-if="processingCompletedible && !startProcessingible">
              <a-button type="primary" style="margin: 20px" @click="endProcessing">接受处理意见 </a-button>
              <a-button type="primary" style="margin: 20px" @click="appealProcessing">申诉</a-button>
            </div>
            <div style="text-align: center" v-if="appealProcessingible">
              <a-button type="primary" style="margin: 20px" @click="appealProcessingsubmit">提交 </a-button>
              <a-button type="primary" style="margin: 20px" @click="appealProcessingcancel">取消</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal v-model="resumeible" title="履历" :width="600" footer="">
      <a-form :form="resumeform" v-if="pendingMattersResume">
        <a-row v-for="(tab, index) in pendingMattersResume">
          <a-col>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题内容">
              {{ tab.content }}
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请人">
              {{ tab.createName }}
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请时间">
              {{ tab.createTime }}
            </a-form-item>

            <div v-if="index != pendingMattersResume.length - 1" style="border: 1px solid #ccc"></div>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal v-model="updateproblemible" @ok="updateproblem()" title="修改" :width="600">
      <a-form :form="updateproblemform">
        <a-row>
          <a-col>
            <a-form-item style="display: none">
              <a-input v-decorator="['feedbackHeaderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题类型">
              <a-input v-decorator="['matterName']" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题内容">
              <a-input
                v-decorator="['contents', { rules: [{ required: true, message: '请填写内容!' }] }]"
                type="textarea"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上传文件">
              <a-upload
                name="file"
                :multiple="true"
                :action="currencyuploadUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :file-list="updatepiclist"
                :headers="headers"
                @change="updatehandleChange"
                @preview="handlePreview1"
              >
                <!--<div v-if="updatepiclist.length < 1">-->
                <a-icon type="upload" />
                <div class="ant-upload-text">图片</div>
                <!--</div>-->
              </a-upload>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请人">
              <a-input v-decorator="['initiatorName']" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请时间">
              <a-input v-decorator="['handleStartTime']" disabled="disabled" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal title="撤回" v-model="deleteible" @ok="deleteOK">
      <p>此操作将确认撤回问题反馈，是否继续？</p>
    </a-modal>

    <a-modal :visible="previewVisible" :footer="null" @cancel="previewhandleCancel">
      <img alt="example" style="width: 100%; padding: 10px" :src="previewImage" />
    </a-modal>
    <a-modal :visible="previewVisible1" :footer="null" @cancel="previewhandleCancel1">
      <img alt="example" style="width: 100%; padding: 10px" :src="previewImage1" />
    </a-modal>
  </a-card>
</template>
<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
import _ from 'lodash'
import {
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getList,
  getOrderDetail,
  getfindByDeptId,
  getfinddictAll
} from '@/api/order/orderList'
import { getselectCombox } from '@/api/order/NewlyaddedOrderList'
import {
  getfeedbacklist,
  getPendingMatterMenu,
  getFeedbackInfo,
  getPendingMattersRoleList,
  gettransfer,
  getPendingMattersResume,
  getupdateFeedback,
  getrevokeFeedback,
  getstartProcessing,
  getreply,
  getprocessingCompleted,
  getendProcessing,
  getappeal
} from '@/api/order/feedback'
import { getAccessoryOrderlist, getselectstore, getdeliverGoods, getAccessoryNumber } from '@/api/order/PartsOrder'
import { getDictMap } from '../../../utils/dict'
import { STable } from '@/components'
import pick from 'lodash.pick'
import moment from 'moment'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { checkPermission } from '@/utils/permissions'
export default {
  name: 'PartsOrder',
  componedefaultFileListnts: {
    STable
    // 注册弹框组件
  },
  data() {
    return {
      feedbackHeaderId: '',
      arrList: [],
      updatepiclist: [],
      previewVisible: false,
      previewVisible1: false,
      previewImage: '',
      previewImage1: '',
      previewimgible: false,
      previewimgurl: '',
      token: Vue.ls.get(ACCESS_TOKEN),
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      currencyuploadUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=feedback',
      process: process.env.VUE_APP_API_BASE_URL + '/dfs/download',
      // 查看问题详情
      details: checkPermission('feedback:details'),
      // 查看处理时长
      // manageTime: checkPermission('manageTime'),
      // 处理
      manage: checkPermission('feedback:manage'),
      // 转派
      dispatcher: checkPermission('feedback:dispatcher'),
      // 问题履历
      questionList: checkPermission('questionList'),
      // 导出
      feedbackexport: checkPermission('feedback:export'),
      findByDeptId: [],
      order_substate: [],
      defaultFileList: [],
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: '操作栏',

          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '处理情况',
          dataIndex: 'handleStatus',
          align: 'center'
        },
        {
          title: '问题类型',
          dataIndex: 'problemType',
          align: 'center'
        },
        {
          title: '状态栏',
          dataIndex: 'statusArea',
          align: 'center'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center'
        },
        {
          title: '订单子状态',
          dataIndex: 'substate',
          align: 'center'
        },
        {
          title: '申请人',
          dataIndex: 'applicant',
          align: 'center'
        },
        {
          title: '申请人联系方式',
          dataIndex: 'applicantPhone',
          align: 'center'
        },
        {
          title: '问题内容',
          dataIndex: 'contents',
          align: 'center'
        },
        {
          title: '申请时间',
          dataIndex: 'applicantTime',
          align: 'center'
        },
        {
          title: '师傅负责人',
          dataIndex: 'masterPrincipal',
          align: 'center'
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center'
        },
        {
          title: '当前协助人',
          dataIndex: 'assistingPeople',
          align: 'center'
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center'
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center'
        },
        {
          title: '客户联系方式',
          dataIndex: 'clientPhone',
          align: 'center'
        },
        {
          title: '客户地址',
          dataIndex: 'province',
          width: '300px'
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          align: 'center'
        },
        {
          title: '师傅联系方式',
          dataIndex: 'masterPhone',
          align: 'center'
        },
        {
          title: '当前处理人',
          dataIndex: 'deal',
          align: 'center'
        },
        {
          title: '处理时长',
          dataIndex: 'dealLongTime',
          align: 'center'
        },
        {
          title: '开始处理时间',
          dataIndex: 'dealStartTime',
          align: 'center'
        },
        {
          title: '处理完成时间',
          dataIndex: 'handle',
          align: 'center'
        },
        {
          title: '总处理时长',
          dataIndex: 'collectDealLongTime',
          align: 'center'
        },
        {
          title: '建单人',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center'
        }
      ],
      loadData: parameter => {
        return getfeedbacklist(Object.assign(parameter, this.queryParam))
      },
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      dtoList: [],
      // 字典为订单状态,
      order_status: [],
      // 字典为安装类型
      installTypes: [],
      List: [],
      // 企业名称
      selectCombox: [],
      getselectstoreList: [],
      dtoListtab: {},
      queryParam: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      pendingMatterMenu: [],
      transferible: false,
      transferform: this.$form.createForm(this),
      dealingform: this.$form.createForm(this),
      resumeform: this.$form.createForm(this),
      updateproblemform: this.$form.createForm(this),
      replyproblemsform: this.$form.createForm(this),
      // 转派 表格
      ransfertrecord: '',
      pendingMattersRoleList: [],
      feedbackInfo: '',
      dealingible: false,
      updateproblemible: false,
      resumeible: false,
      deleteible: false,
      startProcessingible: false,
      processingCompletedible: false,
      appealProcessingible: false,
      detailsViewible: false,
      pendingMattersResume: [],
      dealinglist: []
    }
  },

  async created() {},
  methods: {
    updatehandleChange(info) {
      const isJpgOrPng = info.file.type === 'image/jpeg' || info.file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('只能上传图片')
      } else {
        this.updatepiclist = info.fileList
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    dealingChange(info) {
      const isJpgOrPng = info.file.type === 'image/jpeg' || info.file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('只能上传图片!')
      } else {
        this.dealinglist = info.fileList
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    async handlePreview(file) {
      if (file.response) {
        this.previewImage =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          file.response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.previewImage =
          process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.$nextTick(() => {
        this.previewVisible = true
      })
    },
    async handlePreview1(file) {
      // console.log(file)
      if (file.response) {
        this.previewImage1 =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          file.response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.previewImage1 =
          process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.$nextTick(() => {
        this.previewVisible1 = true
      })
    },
    previewhandleCancel() {
      this.previewVisible = false
    },
    previewhandleCancel1() {
      this.previewVisible1 = false
    },
    // 申诉
    appealProcessing() {
      this.appealProcessingible = true
      this.startProcessingible = true
      setTimeout(() => {
        this.replyproblemsform.setFieldsValue(pick(this.feedbackInfo, 'feedbackHeaderId'))
      }, 100)
    },
    // 取消申诉
    appealProcessingcancel() {
      this.startProcessingible = false
      this.appealProcessingible = false
      this.processingCompletedible = true
    },
    // 申诉确定
    appealProcessingsubmit() {
      let that = this
      this.replyproblemsform.validateFields((err, values) => {
        values.headerId = values.feedbackHeaderId
        let arr = []
        this.dealinglist.forEach(tab => {
          if (tab.response) {
            if (tab.response.code == 0) {
              let obj = {}
              obj.url = tab.response.url
              obj.uid = tab.uid
              obj.name = tab.name
              tab = obj
            }
          }
          arr.push(JSON.stringify(tab))
        })
        values.picUrlList = arr
        if (!err) {
          getappeal(values).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.replyproblemsform.setFieldsValue({
                contents: ''
              })
              this.dealinglist = []
              this.$message.success(res.msg)
              this.$emit('ok')
              this.appealProcessingible = false
              this.startProcessingible = true
              this.interfaceReset(this.feedbackInfo.feedbackHeaderId)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 开始处理
    startProcessing() {
      let that = this
      getstartProcessing({ feedbackHeaderId: this.feedbackInfo.feedbackHeaderId }).then(res => {
        if (res.code === 0) {
          this.startProcessingible = true
          this.$emit('ok')
          setTimeout(() => {
            this.replyproblemsform.setFieldsValue(pick(this.feedbackInfo, 'feedbackHeaderId'))
          }, 100)
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 回复
    replyproblems() {
      let that = this
      this.startProcessing()
      this.replyproblemsform.validateFields((err, values) => {
        let arr = []
        this.dealinglist.forEach(tab => {
          if (tab.response) {
            if (tab.response.code == 0) {
              let obj = {}
              obj.url = tab.response.url
              obj.uid = tab.uid
              obj.name = tab.name
              tab = obj
            }
          }
          arr.push(JSON.stringify(tab))
        })
        values.picUrlList = arr
        if (!err) {
          getreply(values).then(res => {
            if (res.code === 0) {
              this.$message.success(res.msg)
              this.$emit('ok')
              this.replyproblemsform.setFieldsValue({
                contents: ''
              })
              this.dealinglist = []
              this.startProcessing(this.feedbackInfo.feedbackHeaderId)
              this.interfaceReset(this.feedbackInfo.feedbackHeaderId)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 处理完成
    processingCompleted() {
      let that = this
      getprocessingCompleted({ feedbackHeaderId: this.feedbackInfo.feedbackHeaderId }).then(res => {
        if (res.code === 0) {
          this.$emit('ok')
          this.startProcessingible = false
          this.processingCompletedible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 接受处理意见
    endProcessing() {
      let that = this
      getendProcessing({ feedbackHeaderId: this.feedbackInfo.feedbackHeaderId }).then(res => {
        if (res.code === 0) {
          this.$emit('ok')
          this.$message.success(res.msg)
          this.dealingible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 确定撤回
    deleteOK() {
      console.log('aaaaa', this)
      console.log('bbbbb', this.feedbackInfo.feedbackHeaderId)
      let that = this
      getrevokeFeedback({ feedbackHeaderId: this.feedbackHeaderId }).then(res => {
        // console.log(res)
        if (res.code === 0) {
          this.deleteible = false
          this.$emit('ok')
          this.dealingible = false
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 撤回
    revoke(record) {
      // this.revokerecord = record
      this.feedbackHeaderId = record.feedbackHeaderId
      this.deleteible = true
    },
    // 修改弹框确定
    updateproblem() {
      let that = this
      this.updateproblemform.validateFields((err, values) => {
        values.headerId = values.feedbackHeaderId
        let arr = []
        this.updatepiclist.forEach(tab => {
          if (tab.response) {
            if (tab.response.code == 0) {
              let obj = {}
              obj.url = tab.response.url
              obj.uid = tab.uid
              obj.name = tab.name
              tab = obj
            }
          } else {
            tab.thumbUrl = ''
          }
          arr.push(JSON.stringify(tab))
          console.log(arr)
        })
        values.picUrlList = arr
        if (!err) {
          getupdateFeedback(values).then(res => {
            if (res.code === 0) {
              this.updateproblemible = false
              this.dealingible = false
              this.$emit('ok')

              this.$message.success(res.msg)
              //this.startProcessing(this.feedbackInfo.feedbackHeaderId)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 修改
    updateFeedback() {
      let that = this
      console.log(this.feedbackInfo)
      this.updatepiclist = []
      this.updateproblemform.resetFields()
      setTimeout(() => {
        this.updateproblemform.setFieldsValue(
          pick(this.feedbackInfo, 'feedbackHeaderId', 'matterName', 'initiatorName', 'handleStartTime')
        )
        this.updateproblemform.setFieldsValue(pick(this.feedbackInfo.itemInfos[0], 'contents'))
      }, 100)
      this.updatepiclist = this.feedbackInfo.itemInfos[0].arrList
      this.updateproblemible = true
    },
    // 履历
    resume(record) {
      console.log(record)
      getPendingMattersResume({ pendingMattersRecordId: record.feedbackHeaderId, matterCode: record.matterCode }).then(
        res => {
          if (res.code === 0) {
            this.resumeible = true
            this.pendingMattersResume = res.data
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    // 转派确定
    addtransfer() {
      let that = this
      this.transferform.validateFields((err, values) => {
        if (!err) {
          gettransfer(values).then(res => {
            if (res.code === 0) {
              this.$emit('ok')
              this.$message.success(res.msg)
              this.transferible = false
              // this.dealingible=false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 转派 表格
    problemsTransfer(record) {
      this.ransfertrecord = record
      console.log(record)
      setTimeout(() => {
        this.transferform.setFieldsValue({
          feedbackHeaderId: record.feedbackHeaderId
        })
      }, 100)
      getPendingMattersRoleList().then(res => {
        if (res.code === 0) {
          this.pendingMattersRoleList = res.data
          this.transferible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 处理弹框 回显
    interfaceReset(id) {
      getFeedbackInfo({ feedbackHeaderId: id }).then(res => {
        let arr = {}
        let that = this
        if (res.code === 0) {
          //
          console.log('ccccc', res)
          this.feedbackInfo = res.data
          this.feedbackInfo.itemInfos.forEach(item => {
            item.arrList = []
            if (item.pics) {
              item.pics.forEach(tab => {
                if (tab.indexOf(':') == -1) {
                  that.getImgToBase64(
                    process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      tab +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                    function(data) {
                      item.arrList.push({
                        uid: tab,
                        thumbUrl: data,
                        url: tab
                      })
                    }
                  )
                } else {
                  let arr = JSON.parse(tab)
                  that.getImgToBase64(
                    process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      arr.url +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                    function(data) {
                      item.arrList.push({
                        uid: arr.uid,
                        thumbUrl: data,
                        url: arr.url
                      })
                    }
                  )
                }
              })
            }
          })
          this.dealingible = true
          setTimeout(() => {
            this.replyproblemsform.setFieldsValue(pick(this.feedbackInfo, 'feedbackHeaderId'))
          }, 100)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 处理 表格
    problemsDealing(record) {
      // console.log('处理',record)
      this.dealingform.resetFields()
      this.replyproblemsform.setFieldsValue({
        contents: ''
      })
      this.dealinglist = []
      this.startProcessingible = false
      this.appealProcessingible = false
      this.processingCompletedible = false
      this.detailsViewible = false
      this.interfaceReset(record.feedbackHeaderId)

      if (record.handlingStatus == '处理中') {
        this.startProcessingible = true
        this.appealProcessingible = false
      } else if (record.handlingStatus == '待确认') {
        this.startProcessingible = false
        this.processingCompletedible = true
      }
    },
    detailsView(record) {
      this.startProcessingible = false
      this.appealProcessingible = false
      this.processingCompletedible = false
      this.detailsViewible = true
      getFeedbackInfo({ feedbackHeaderId: record.feedbackHeaderId }).then(res => {
        if (res.code === 0) {
          this.feedbackInfo = res.data
          this.dealingible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 市
    getselect(e) {
      getselectCityName({ provinceCode: e }).then(res => {
        if (res.code === 0) {
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onChangerangepicker(date, dateString) {
      this.dtoListtab.timeStart = dateString[0]
      this.dtoListtab.timeEnd = dateString[1]
      // console.log(this.dtoListtab.timeType)
      this.dtoList.push(this.dtoListtab)
      console.log(this.dtoList)
    },
    //将图片转换为Base64
    getImgToBase64(url, callback) {
      var canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d'),
        img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function() {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL('image/png')
        callback(dataURL)
        canvas = null
      }
      img.src = url
    },
    async installChange(e) {
      this.queryParam.orderType = ''
      this.List = []
      await getList(e).then(res => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.video {
  width: 140px;
  height: 180px;
  margin: 5px;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 6px 16px;
}
</style>
